import '@lottiefiles/lottie-player'

export default defineNuxtPlugin(() => {})
